import BackendService from "../../../backend/controller/BackendService";
import LlmConversationMessage, { LlmMessageSender } from "../../../conversation/model/LlmConversationMessage";
import PlayerModel from "../../../player/model/PlayerModel";
import LlmMessagePrefixer from "../../../util/LlmMessagePrefixer";
import ConversationReflection from "../../model/ConversationReflection";
import ConversationReflectionMessage, { ReflectionMessageSender } from "../../model/ConversationReflectionMessage";
import AiTurnConversationReflectionState from "./AiTurnConversationReflectionState";
import ConversationReflectionState from "./ConversationReflectionState";
import EndingTurnConversationReflectionState from "./EndingTurnConversationReflectionState";

export default class PlayerTurnConversationReflectionState extends ConversationReflectionState {
    constructor() {
        super();

        this._playerInputPromise = new Promise((resolve) => {
            this._resolvePromise = resolve;
        });
    }

    /**
     * 
     * @param {string} chapterId
     * @param {ConversationReflection} conversation 
     * @param {BackendService} backendService 
     * @param {PlayerModel} playerModel
     * @returns {Promise<ConversationReflectionState>}
     */
    async execute(chapterId, conversation, backendService, playerModel) {
        const playerInput = await this._playerInputPromise;
        const playerName = playerModel.getTrimmedPlayerName();
        const labeledPlayerInput = LlmMessagePrefixer.prefixMessageAsPlayer(playerInput, playerName);

        conversation.addConversationHistory({
            llmConversationMessages: [new LlmConversationMessage(LlmMessageSender.USER, labeledPlayerInput)],
            gameConversationMessages: [new ConversationReflectionMessage(ReflectionMessageSender.PLAYER, playerInput)],
        });

        conversation.bumpTurns();

        // Check if we've reached a time-out.
        console.log(`Turn ${conversation.turns}/${conversation.maxPlayerTurns}. Turns to go: ${conversation.maxPlayerTurns - conversation.turns}.`);
        if (conversation.turns >= conversation.maxPlayerTurns) {
            const nextState = new EndingTurnConversationReflectionState();
            return Promise.resolve(nextState);
        }

        const nextState = new AiTurnConversationReflectionState();
        return Promise.resolve(nextState);
    }

    async reset() {
        // Reset the promise for the next player input.
        this._playerInputPromise = new Promise((resolve) => {
            this._resolvePromise = resolve;
        });
    }

    /**
     * 
     * @param {string} message 
     */
    handlePlayerInput(message) {
        this._resolvePromise(message);
    }
}